import Vue from 'vue'
import Vuex from 'vuex'
import { AdminStore } from "./store/admin_store"
import { CommonStore } from "./store/common_store"
import { CompanyStore } from "./store/company_store"
import { ParkStore } from "./store/park_store"

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    park: ParkStore,
    admin: AdminStore,
    company: CompanyStore,
    commom: CommonStore
  }
})
